export default {"src":"/_next/static/media/image_grey.a7201e61.svg","height":19,"width":19};